import React, { FC, memo } from 'react';
import styled from 'styled-components';
import Input from 'components/UI/Input';
import { InputProps } from 'components/UI/Input/Input';
import { SearchIcon } from 'primereact/icons/search';
import { InputAdornment } from '@mui/material';

const StyledInput = styled(Input)`
  background-color: var(--surface-0);
  color: var(--text-color);
  margin: 0px 0px 10px 0px;

  .MuiOutlinedInput-input {
    padding: 5px 14px;
  }

  .MuiInputBase-root {
    height: 34px;
  }
`;

const SearchInput: FC<InputProps> = ({ ...rest }) => {
  return (
    <StyledInput
      id="outlined-start-adornment"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};

export default memo(SearchInput);
